import { shallowEqual } from 'react-redux';

import { Alert } from '@zillow/constellation-10';

import { useSelector } from '../../../selectors/useSelector';

const PartialListingBanner = () => {
  const {
    isFeed,
    partialListing: { isPartialListingManaged, partialFeedName },
  } = useSelector(
    (state) => ({
      isFeed: state?.properties?.currentProperty?.isFeed,
      partialListing: state?.properties?.currentProperty?.partialListing,
    }),
    shallowEqual,
  );

  if (isFeed || !isPartialListingManaged) {
    return null;
  }

  return (
    <Alert tone="info" css={{ marginBottom: '600' }}>
      {partialFeedName} is the pricing and availability source for this listing. Edits to property details and media can
      be made on Zillow, but edits to availability and pricing must be made through {partialFeedName}.
    </Alert>
  );
};

export default PartialListingBanner;
